import { render, staticRenderFns } from "./TaskListPageHeader.vue?vue&type=template&id=e6860784"
import script from "./TaskListPageHeader.vue?vue&type=script&lang=js"
export * from "./TaskListPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports